import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from '../Home';
import Enrollment from '../Enrollment';
import PathSelectionReadMore from '../Enrollment/PathSelection/PathSelectionReadMore';
import AuthProvider from '../AuthProvider';
import PrivateRoute from '../PrivateRoute';
import Modal from '../Modal';
import LogIn from '../LogIn';
import SignUp from '../SignUp';
import SignUpConfirmation from '../SignUp/SignUpConfirmation';

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Modal />
        <Routes>
          <Route path="/" element={<PrivateRoute Component={Home} />} />
          <Route path="/login" Component={LogIn} />
          <Route path="/signup" Component={SignUp} />
          <Route path="/signup/confirmation" Component={SignUpConfirmation} />
          <Route
            path="/enrollment"
            element={
              <PrivateRoute Component={Enrollment} requireNotification />
            }
          />
          <Route
            path="/path-selection-read-more"
            element={
              <PrivateRoute
                Component={PathSelectionReadMore}
                requireNotification
              />
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
